// Caché local del catálogo (productos, categorías, settings, áreas) por restaurante.
// Permite que el POS cargue al instante y funcione sin conexión.

const prefix = "pos_catalog_";
const keyFor = (name) => `${prefix}${name}`;

export function saveCatalog(name, data) {
  try {
    localStorage.setItem(keyFor(name), JSON.stringify({ at: Date.now(), data }));
  } catch {
    /* almacenamiento lleno o no disponible */
  }
}

export function loadCatalog(name) {
  try {
    const raw = localStorage.getItem(keyFor(name));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.data ?? null;
  } catch {
    return null;
  }
}

export function genClientId() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch {
    /* ignore */
  }
  return `off-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
